import { connect } from 'react-redux';
import Global from '../../store/global-selectors';
import ScanToBatchButton from '../../components/batches/scan-to-batch';
import { openScanToBatchModal } from '../../store/batches/scan-to-batch/scan-to-batch.actions';

const mapStateToProps = (state) => {
  const batch = Global.selectBatchDetailsBatch(state);
  return {
    batch,
  };
};

const mapDispatchToProps = {
  openScanToBatchModal,
};

export const ScanToBatchContainer = connect(mapStateToProps, mapDispatchToProps)(ScanToBatchButton);
